// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider-module--divider--1wfxg","phone":"divider-module--phone--24whB","tabPort":"divider-module--tab-port--3iGPG"};